// @ts-nocheck

import React from 'react';
import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import { IconButton } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import styles from './studyCard.module.css';
import AtomCustomCard from '../../atoms/CustomCard';
interface ProgressCardProps {
  className: string;
  onClick?: () => void;
  id: string;
  time_created: string;
  time_updated: string;
  last_edited_by: {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    is_active: boolean;
    is_new: boolean;
  };
  description: string;
  analyst: string;
  name: string;
  status: string;
  metrics: [
    {
      status: string;
      count: number;
      revenues: number;
    },
  ];
  progress: number;
  number_of_companies: number;
  total_market_size: number;
  onDelete?: (event: React.MouseEvent) => void;
}

const OrgStudyCard: React.FC<ProgressCardProps> = ({
  id,
  time_created,
  time_updated,
  last_edited_by,
  description,
  analyst,
  name,
  status,
  number_of_companies,
  total_market_size,
  metrics,
  progress,
  className,
  onClick,
  onDelete,
}) => {
  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'modelled':
        return '#093fc3';
      case 'revised':
        return '#BBBCBE';
      case 'override':
        return '#FB923C';
      case 'supplier_input':
        return '#22C55E';
      default:
        return '#093fc3';
    }
  };

  // Filter and map in a single pass for better performance
  const pieData = [];

  // Process metrics in a single loop
  metrics.forEach((metric, index) => {
    if (metric.count > 0) {
      pieData.push({
        id: pieData.length, // Use current array length for sequential IDs
        label: metric.status,
        value: metric.count,
        color: getStatusColor(metric.status),
      });
    }
  });

  const pieChartProps = {
    height: 250,
    // width: 250,
    margin: { top: 20, right: 20, bottom: 60, left: 20 },
    series: [
      {
        innerRadius: 40,
        cornerRadius: 5,
        paddingAngle: 5,
      },
    ],
    slotProps: {
      legend: {
        direction: 'row',
        position: { vertical: 'bottom', horizontal: 'middle' },
        hidden: false,
        padding: { top: 20, bottom: 0, left: 0, right: 0 },
        labelStyle: {
          fontSize: 12,
          textTransform: 'capitalize',
        },
        itemMarkWidth: 10,
        itemMarkHeight: 10,
        markGap: 5,
        itemGap: 10,
      },
    },
  };

  const pieParams = {
    // margin: { right: 5 },
  };
  return (
    <AtomCustomCard className={className} onClick={onClick}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h3 className={styles.title}>{name}</h3>
          {/* <h1 className={styles.percentage}>{(progress * 100).toFixed(2)}%</h1> */}
          <h1 className={styles.percentage}>
            {' '}
            {new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(total_market_size)}
          </h1>

          <h5>No. Suppliers: {number_of_companies}</h5>
          {/* <h5>
            Total market revenue:{' '}
            {new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(total_market_size)}
          </h5> */}
          <h5>Revenue YoY: {(progress * 100).toFixed(2)}%</h5>
        </div>
        <IconButton size="small" aria-label="delete" onClick={onDelete} className={styles.delete}>
          <DeleteOutlined fontSize="small" />
        </IconButton>
      </div>
      <div className={styles.progressList}>
        <div className={styles.chartsContainer}>
          <div className={styles.chartWrapper}>
            <PieChart
              {...pieChartProps}
              series={[
                {
                  ...pieChartProps.series[0],
                  data: pieData,
                },
              ]}
              tooltip={{
                trigger: 'item',
                itemContent: props => {
                  const { series, itemData } = props;
                  if (!itemData) return null;

                  const metricData = metrics.find(
                    m =>
                      m.status.toLowerCase() === series.data[itemData.dataIndex].label.toLowerCase()
                  );

                  return (
                    <div className={styles.toolTip}>
                      <h3 className={styles.contentDetailsKey}>
                        {series.data[itemData.dataIndex].label}
                      </h3>
                      <div className={styles.toolTipContent}>
                        <h3 className={styles.contentDetailsKey}>Counts:</h3>
                        <h3 className={styles.contentDetailsValue}>
                          {series.data[itemData.dataIndex].value}
                        </h3>
                      </div>
                      <div className={styles.toolTipContent}>
                        <h3 className={styles.contentDetailsKey}>Revenue:</h3>
                        <h3 className={styles.contentDetailsValue}>
                          {new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(metricData.revenues)}
                        </h3>
                      </div>
                    </div>
                  );
                },
              }}
            />
          </div>
        </div>
      </div>
    </AtomCustomCard>
  );
};

export default OrgStudyCard;
